var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTestResultsNumberOfAttempts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10561_12764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5546 2.29978L13.1429 5.49402C13.3569 5.93578 13.9314 6.35488 14.4158 6.44549L17.2884 6.92123C19.1245 7.22706 19.5526 8.56366 18.2346 9.90026L15.9929 12.1543C15.6212 12.5281 15.4071 13.2644 15.531 13.7968L16.1731 16.5832C16.6801 18.7807 15.5085 19.6415 13.5822 18.4862L10.8899 16.8777C10.4055 16.5832 9.59447 16.5832 9.11008 16.8777L6.41778 18.4862C4.49149 19.6302 3.31994 18.7807 3.82686 16.5832L4.46896 13.7968C4.59287 13.2757 4.37884 12.5395 4.0071 12.1543L1.76539 9.90026C0.447407 8.57499 0.875471 7.23839 2.71164 6.92123L5.58418 6.44549C6.06857 6.36621 6.64308 5.93578 6.85711 5.49402L8.44545 2.29978C9.29032 0.566739 10.6872 0.566739 11.5546 2.29978Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10561_12764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTestResultsNumberOfAttempts);
export default ForwardRef;